<template>
<span>
    <b-button :size="size" :id="id" :class="{'btn-multiple-state': true,
                    'show-spinner': status === 'processing',
                    'show-success':status === 'success',
                    'show-fail': status === 'fail' }" :variant="variant" @click="handleClick"
              :disabled="status !== 'default'">
        <span class="spinner d-inline-block">
            <span class="bounce1"></span>
            <span class="bounce2"></span>
            <span class="bounce3"></span>
        </span>
        <span class="icon success">
            <i class="simple-icon-check"></i>
        </span>
        <span class="icon fail">
            <i class="simple-icon-exclamation"></i>
        </span>
        <span class="label">
            <slot></slot>
        </span>
    </b-button>
</span>
</template>

<script>
    export default {
        props: ['id', 'variant', 'click', 'size'],
        data() {
            return {
                status: 'default',
            }
        },
        methods: {
            handleClick() {
                this.status = 'processing';
                this.click()
                    .then(res => {
                        this.status = 'success';
                    })
                    .catch(err => {
                        this.status = 'fail';
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.status = 'default';
                        }, 3000)
                    });
            }
        }
    }
</script>
